import { useCountdown } from 'hooks/draw/useCountdown';
import styles from './DrawCounter.module.css';

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

interface DrawCounterProps {
  targetDate: Date;
  /** Whether the component should provide any margins or paddings */
  bare?: boolean;
  /** The text to show above the counter. The default text will be for nullish
   * values. You can provide empty-string to show no text
   */
  introText?: string | undefined | null;
}

const DrawCounter = ({ targetDate, bare, introText }: DrawCounterProps) => {
  const { paddedTimeLeft } = useCountdown(targetDate);

  return (
    <div className={bare ? undefined : styles.container}>
      <span className={` ${styles.nextDraw}`}>
        {introText ?? 'Next draw in'}
      </span>
      <div className={styles.countdown}>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.days}</span>
          <span className={` ${styles.label}`}>Days</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.hours}</span>
          <span className={` ${styles.label}`}>Hrs</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.minutes}</span>
          <span className={` ${styles.label}`}>Mins</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.seconds}</span>
          <span className={`${styles.label}`}>Secs</span>
        </div>
      </div>
    </div>
  );
};

export default DrawCounter;
